// extracted by mini-css-extract-plugin
module.exports = {"title":"Classpage_title__1UGMj","grid":"Classpage_grid__3ZlIm"};